import type { DatabaseExternalFile, ExternalFile } from '@/lib/types';
import { useContext } from 'react';
import ExternalFilesContext from '../ExternalFilesContext';
import api from '@/lib/api';

const useAddExternalFiles = () => {
  const { externalFilesEndpoint, addExternalFileToLocalState } =
    useContext(ExternalFilesContext);

  const addExternalFiles = async (
    externalFiles: ExternalFile[],
  ): Promise<void> => {
    const externalFilesResponse = await api.post<
      Record<number, DatabaseExternalFile>
    >(externalFilesEndpoint, {
      externalFiles,
    });

    for (const externalFile of Object.values(externalFilesResponse)) {
      addExternalFileToLocalState(externalFile);
    }
  };

  return addExternalFiles;
};

export default useAddExternalFiles;
